import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "p-6 max-w-7xl mx-auto" }
const _hoisted_2 = { class: "flex items-center justify-between mb-6" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 0,
  class: "w-4 h-4 mr-2",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_5 = {
  key: 1,
  class: "w-4 h-4 mr-2 animate-spin",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_6 = {
  key: 0,
  class: "mb-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg"
}
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "text-blue-800 dark:text-blue-200 font-medium" }
const _hoisted_9 = { class: "ml-4 text-blue-600 dark:text-blue-300 text-sm" }
const _hoisted_10 = { class: "mb-6" }
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = {
  key: 1,
  class: "mb-6 p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg"
}
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = { class: "text-red-800 dark:text-red-200" }
const _hoisted_15 = {
  key: 2,
  class: "flex items-center justify-center py-12"
}
const _hoisted_16 = {
  key: 3,
  class: "space-y-6"
}
const _hoisted_17 = { class: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3" }
const _hoisted_18 = { class: "font-mono text-sm text-gray-900 dark:text-white" }
const _hoisted_19 = { class: "space-y-4" }
const _hoisted_20 = { class: "font-semibold text-gray-900 dark:text-white mb-3" }
const _hoisted_21 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4 text-sm" }
const _hoisted_22 = { class: "flex flex-wrap gap-1" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "space-y-2" }
const _hoisted_25 = { class: "flex flex-wrap gap-1" }
const _hoisted_26 = { class: "space-y-4" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "flex items-center justify-between" }
const _hoisted_29 = { class: "font-semibold text-gray-900 dark:text-white" }
const _hoisted_30 = { class: "flex items-center" }
const _hoisted_31 = { class: "mr-3 text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_32 = { class: "px-4 pb-4 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_33 = { class: "flex flex-wrap gap-2 pt-3" }
const _hoisted_34 = { class: "space-y-4" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex items-center justify-between" }
const _hoisted_37 = { class: "font-semibold text-gray-900 dark:text-white" }
const _hoisted_38 = { class: "flex items-center" }
const _hoisted_39 = { class: "mr-3 text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_40 = { class: "px-4 pb-4 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_41 = { class: "flex flex-wrap gap-2 pt-3" }
const _hoisted_42 = { class: "space-y-4" }
const _hoisted_43 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-4" }
const _hoisted_44 = { class: "font-mono text-sm bg-gray-50 dark:bg-gray-900 p-2 rounded border" }
const _hoisted_45 = { class: "inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-indigo-100 dark:bg-indigo-900 text-indigo-800 dark:text-indigo-200" }
const _hoisted_46 = {
  key: 4,
  class: "text-center py-12"
}

import { ref, computed, onMounted } from 'vue'
import type { IIAMConfig } from '../../types/iam-config'
import { iamConfigService } from '../../services/iam/iamConfigService'
import ExpandableSection from './components/ExpandableSection.vue'

// State

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const iamConfig = ref<IIAMConfig | null>(null)
const loading = ref(false)
const error = ref<string | null>(null)
const searchQuery = ref('')
const expandedSections = ref({
  scopes: true,
  scopeConfigs: true,
  userRoleScopes: true,
  userRoleAssignedScopes: true,
  urlScopeMap: true
})

// State for individual role section expansion
const expandedRoleSections = ref<Record<string, boolean>>({})
const expandedAssignedRoleSections = ref<Record<string, boolean>>({})

// Computed properties for filtering
const filteredScopes = computed(() => {
  if (!iamConfig.value) return []
  if (!searchQuery.value) return iamConfig.value.config.scopes
  
  return iamConfig.value.config.scopes.filter(scope =>
    scope.toLowerCase().includes(searchQuery.value.toLowerCase())
  )
})

const filteredScopeConfigs = computed(() => {
  if (!iamConfig.value) return []
  if (!searchQuery.value) return Object.entries(iamConfig.value.config.scopeConfigs)
  
  return Object.entries(iamConfig.value.config.scopeConfigs).filter(([scopeName, config]) =>
    scopeName.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    config.whoCanAccessAuthClasses.some(authClass => 
      authClass.toLowerCase().includes(searchQuery.value.toLowerCase())
    )
  )
})

const filteredUserRoleScopes = computed(() => {
  if (!iamConfig.value) return []
  if (!searchQuery.value) return Object.entries(iamConfig.value.config.userRoleScopesMap)
  
  return Object.entries(iamConfig.value.config.userRoleScopesMap).filter(([role, scopes]) =>
    role.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    scopes.some(scope => scope.toLowerCase().includes(searchQuery.value.toLowerCase()))
  )
})

const filteredUserRoleAssignedScopes = computed(() => {
  if (!iamConfig.value) return []
  if (!searchQuery.value) return Object.entries(iamConfig.value.config.userRoleAssignedScopesMap)
  
  return Object.entries(iamConfig.value.config.userRoleAssignedScopesMap).filter(([role, scopes]) =>
    role.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    scopes.some(scope => scope.toLowerCase().includes(searchQuery.value.toLowerCase()))
  )
})

const filteredUrlScopeMap = computed(() => {
  if (!iamConfig.value) return []
  if (!searchQuery.value) return Object.entries(iamConfig.value.config.urlScopeMap)
  
  return Object.entries(iamConfig.value.config.urlScopeMap).filter(([url, scope]) =>
    url.toLowerCase().includes(searchQuery.value.toLowerCase()) ||
    scope.toLowerCase().includes(searchQuery.value.toLowerCase())
  )
})

const lastUpdated = computed(() => {
  if (!iamConfig.value) return ''
  return new Date().toLocaleString()
})

// Methods
const loadConfig = async () => {
  try {
    loading.value = true
    error.value = null
    iamConfig.value = await iamConfigService.fetchIAMConfig()
  } catch (err) {
    error.value = err instanceof Error ? err.message : 'An unexpected error occurred'
  } finally {
    loading.value = false
  }
}

const refreshConfig = async () => {
  await loadConfig()
}

// Toggle methods for role sections
const toggleRoleSection = (role: string) => {
  expandedRoleSections.value[role] = !expandedRoleSections.value[role]
}

const toggleAssignedRoleSection = (role: string) => {
  expandedAssignedRoleSections.value[role] = !expandedAssignedRoleSections.value[role]
}

// Load config on mount
onMounted(() => {
  // Don't auto-load - wait for user action
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createStaticVNode("<div><h1 class=\"text-3xl font-bold text-gray-900 dark:text-white\">IAM Configuration</h1><p class=\"text-gray-600 dark:text-gray-400 mt-2\"> View current IAM scopes, permissions, and role mappings </p><div class=\"mt-2\"><span class=\"inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200\"><svg class=\"w-4 h-4 mr-1\" fill=\"currentColor\" viewBox=\"0 0 20 20\"><path fill-rule=\"evenodd\" d=\"M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z\" clip-rule=\"evenodd\"></path></svg> Staging Environment </span></div></div>", 1)),
      _createElementVNode("button", {
        onClick: refreshConfig,
        disabled: loading.value,
        class: "inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
      }, [
        (!loading.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[6] || (_cache[6] = [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
              }, null, -1)
            ])))
          : (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[7] || (_cache[7] = [
              _createElementVNode("circle", {
                class: "opacity-25",
                cx: "12",
                cy: "12",
                r: "10",
                stroke: "currentColor",
                "stroke-width": "4"
              }, null, -1),
              _createElementVNode("path", {
                class: "opacity-75",
                fill: "currentColor",
                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              }, null, -1)
            ]))),
        _createTextVNode(" " + _toDisplayString(loading.value ? 'Refreshing...' : 'Refresh Config'), 1)
      ], 8, _hoisted_3)
    ]),
    (iamConfig.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[9] || (_cache[9] = _createElementVNode("svg", {
              class: "w-5 h-5 text-blue-500 mr-2",
              fill: "currentColor",
              viewBox: "0 0 20 20"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z",
                "clip-rule": "evenodd"
              })
            ], -1)),
            _createElementVNode("span", _hoisted_8, " Configuration Version: " + _toDisplayString(iamConfig.value.version), 1),
            _createElementVNode("span", _hoisted_9, " Last updated: " + _toDisplayString(lastUpdated.value), 1),
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "ml-4 text-blue-600 dark:text-blue-300 text-sm" }, " Environment: Staging ", -1))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" }, [
          _createElementVNode("svg", {
            class: "h-5 w-5 text-gray-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            })
          ])
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
          type: "text",
          placeholder: "Search scopes, roles, or permissions...",
          class: "block w-full pl-10 pr-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md leading-5 bg-white dark:bg-gray-800 text-gray-900 dark:text-white placeholder-gray-500 dark:placeholder-gray-400 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-400 dark:focus:border-blue-400"
        }, null, 512), [
          [_vModelText, searchQuery.value]
        ])
      ])
    ]),
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[12] || (_cache[12] = _createElementVNode("svg", {
              class: "w-5 h-5 text-red-500 mr-2",
              fill: "currentColor",
              viewBox: "0 0 20 20"
            }, [
              _createElementVNode("path", {
                "fill-rule": "evenodd",
                d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
                "clip-rule": "evenodd"
              })
            ], -1)),
            _createElementVNode("span", _hoisted_14, _toDisplayString(error.value), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (loading.value && !iamConfig.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, _cache[13] || (_cache[13] = [
          _createStaticVNode("<div class=\"text-center\"><svg class=\"mx-auto h-12 w-12 text-gray-400 animate-spin\" fill=\"none\" viewBox=\"0 0 24 24\"><circle class=\"opacity-25\" cx=\"12\" cy=\"12\" r=\"10\" stroke=\"currentColor\" stroke-width=\"4\"></circle><path class=\"opacity-75\" fill=\"currentColor\" d=\"M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z\"></path></svg><p class=\"mt-2 text-gray-600 dark:text-gray-400\">Loading IAM configuration...</p></div>", 1)
        ])))
      : _createCommentVNode("", true),
    (iamConfig.value && !loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createVNode(ExpandableSection, {
            title: "Defined Scopes",
            count: filteredScopes.value.length,
            "is-expanded": expandedSections.value.scopes,
            onToggle: _cache[1] || (_cache[1] = ($event: any) => (expandedSections.value.scopes = !expandedSections.value.scopes))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredScopes.value, (scope) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: scope,
                    class: "p-3 bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg"
                  }, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(scope), 1)
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["count", "is-expanded"]),
          _createVNode(ExpandableSection, {
            title: "Scope Configurations",
            count: filteredScopeConfigs.value.length,
            "is-expanded": expandedSections.value.scopeConfigs,
            onToggle: _cache[2] || (_cache[2] = ($event: any) => (expandedSections.value.scopeConfigs = !expandedSections.value.scopeConfigs))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredScopeConfigs.value, ([scopeName, config]) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: scopeName,
                    class: "p-4 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg"
                  }, [
                    _createElementVNode("h4", _hoisted_20, _toDisplayString(scopeName), 1),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", null, [
                        _cache[14] || (_cache[14] = _createElementVNode("h5", { class: "font-medium text-gray-700 dark:text-gray-300 mb-2" }, "Auth Classes", -1)),
                        _createElementVNode("div", _hoisted_22, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.whoCanAccessAuthClasses, (authClass) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: authClass,
                              class: "px-2 py-1 bg-blue-100 dark:bg-blue-900 text-blue-800 dark:text-blue-200 text-xs rounded"
                            }, _toDisplayString(authClass), 1))
                          }), 128))
                        ])
                      ]),
                      (config.whoCanAccessIstioMeshApis && config.whoCanAccessIstioMeshApis.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _cache[16] || (_cache[16] = _createElementVNode("h5", { class: "font-medium text-gray-700 dark:text-gray-300 mb-2" }, "Istio Mesh APIs", -1)),
                            _createElementVNode("div", _hoisted_24, [
                              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "flex items-center p-2 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-md" }, [
                                _createElementVNode("svg", {
                                  class: "w-4 h-4 text-yellow-600 dark:text-yellow-400 mr-2",
                                  fill: "currentColor",
                                  viewBox: "0 0 20 20"
                                }, [
                                  _createElementVNode("path", {
                                    "fill-rule": "evenodd",
                                    d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                                    "clip-rule": "evenodd"
                                  })
                                ]),
                                _createElementVNode("span", { class: "text-xs text-yellow-800 dark:text-yellow-200 font-medium" }, " This check is not yet implemented in IAM ")
                              ], -1)),
                              _createElementVNode("div", _hoisted_25, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(config.whoCanAccessIstioMeshApis, (api) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: api,
                                    class: "px-2 py-1 bg-yellow-100 dark:bg-yellow-900 text-yellow-800 dark:text-yellow-200 text-xs rounded"
                                  }, _toDisplayString(api), 1))
                                }), 128))
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["count", "is-expanded"]),
          _createVNode(ExpandableSection, {
            title: "User Role Scopes",
            count: filteredUserRoleScopes.value.length,
            "is-expanded": expandedSections.value.userRoleScopes,
            onToggle: _cache[3] || (_cache[3] = ($event: any) => (expandedSections.value.userRoleScopes = !expandedSections.value.userRoleScopes))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_26, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUserRoleScopes.value, ([role, scopes]) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: role,
                    class: "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden"
                  }, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (toggleRoleSection(role)),
                      class: "w-full p-4 text-left hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset"
                    }, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("h4", _hoisted_29, _toDisplayString(role), 1),
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("span", _hoisted_31, _toDisplayString(scopes.length) + " scope" + _toDisplayString(scopes.length !== 1 ? 's' : ''), 1),
                          (_openBlock(), _createElementBlock("svg", {
                            class: _normalizeClass(["w-5 h-5 text-gray-500 dark:text-gray-400 transform transition-transform duration-200", { 'rotate-180': expandedRoleSections.value[role] }]),
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, _cache[17] || (_cache[17] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M19 9l-7 7-7-7"
                            }, null, -1)
                          ]), 2))
                        ])
                      ])
                    ], 8, _hoisted_27),
                    _withDirectives(_createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scopes, (scope) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: scope,
                            class: "px-2 py-1 bg-green-100 dark:bg-green-900 text-green-800 dark:text-green-200 text-sm rounded"
                          }, _toDisplayString(scope), 1))
                        }), 128))
                      ])
                    ], 512), [
                      [_vShow, expandedRoleSections.value[role]]
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["count", "is-expanded"]),
          _createVNode(ExpandableSection, {
            title: "User Role Assigned Scopes",
            count: filteredUserRoleAssignedScopes.value.length,
            "is-expanded": expandedSections.value.userRoleAssignedScopes,
            onToggle: _cache[4] || (_cache[4] = ($event: any) => (expandedSections.value.userRoleAssignedScopes = !expandedSections.value.userRoleAssignedScopes))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_34, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUserRoleAssignedScopes.value, ([role, scopes]) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: role,
                    class: "bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg overflow-hidden"
                  }, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (toggleAssignedRoleSection(role)),
                      class: "w-full p-4 text-left hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-inset"
                    }, [
                      _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("h4", _hoisted_37, _toDisplayString(role), 1),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("span", _hoisted_39, _toDisplayString(scopes.length) + " scope" + _toDisplayString(scopes.length !== 1 ? 's' : ''), 1),
                          (_openBlock(), _createElementBlock("svg", {
                            class: _normalizeClass(["w-5 h-5 text-gray-500 dark:text-gray-400 transform transition-transform duration-200", { 'rotate-180': expandedAssignedRoleSections.value[role] }]),
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, _cache[18] || (_cache[18] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M19 9l-7 7-7-7"
                            }, null, -1)
                          ]), 2))
                        ])
                      ])
                    ], 8, _hoisted_35),
                    _withDirectives(_createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scopes, (scope) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: scope,
                            class: "px-2 py-1 bg-purple-100 dark:bg-purple-900 text-purple-800 dark:text-purple-200 text-sm rounded"
                          }, _toDisplayString(scope), 1))
                        }), 128))
                      ])
                    ], 512), [
                      [_vShow, expandedAssignedRoleSections.value[role]]
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["count", "is-expanded"]),
          _createVNode(ExpandableSection, {
            title: "Endpoint Scope Mapping",
            count: filteredUrlScopeMap.value.length,
            "is-expanded": expandedSections.value.urlScopeMap,
            onToggle: _cache[5] || (_cache[5] = ($event: any) => (expandedSections.value.urlScopeMap = !expandedSections.value.urlScopeMap))
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_42, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredUrlScopeMap.value, ([url, scope]) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: url,
                    class: "p-4 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg"
                  }, [
                    _createElementVNode("div", _hoisted_43, [
                      _createElementVNode("div", null, [
                        _cache[19] || (_cache[19] = _createElementVNode("h5", { class: "font-medium text-gray-700 dark:text-gray-300 mb-2" }, "Endpoint", -1)),
                        _createElementVNode("div", _hoisted_44, _toDisplayString(url), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[20] || (_cache[20] = _createElementVNode("h5", { class: "font-medium text-gray-700 dark:text-gray-300 mb-2" }, "Maps to Scope", -1)),
                        _createElementVNode("span", _hoisted_45, _toDisplayString(scope), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["count", "is-expanded"])
        ]))
      : _createCommentVNode("", true),
    (!iamConfig.value && !loading.value && !error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createElementVNode("button", {
            onClick: loadConfig,
            class: "inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          }, " Load IAM Configuration ")
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})